import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FFlowModule } from '@foblex/flow';
import { FlowNodeComponent } from '../flow-node/flow-node.component';

@Component({
  selector: 'iot-platform-ui-flow-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FFlowModule],
  template: `
    <div class="group-wrapper h-full min-h-38 w-full min-w-82.5" data-test="group-wrapper">
      @if (node()?.label) {
        <div class="group-pill-header {{ node()?.headerCssClassName }}" fDragHandle data-test="group-label">{{ node()?.label }}</div>
      }
      <!-- Group Body - Empty, children are rendered outside as siblings -->
      <div class="group-content" data-test="group-content">
        <!-- Children will be positioned here by Foblex based on fNodeParentId -->
      </div>
    </div>
  `
})
export class FlowGroupComponent extends FlowNodeComponent {}
